import React, { useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';

import CategoryToolTile from './CategoryToolTile';
import { AMPLITUDE } from '../../../lib/constants';

const SearchRow = props => {
  const {
    fptiClick,
    toolTileProps: {
      flatPSData: { tools, categories, isNewLayoutEligible },
      toolServFavorites = {}
    },
    appSearch: { results = [], query = '' },
    clearSearch,
    shouldShowModal,
    dispatch
  } = props;

  const { SEARCH_FIELD_CLICK } = AMPLITUDE;

  useEffect(
    () =>
      fptiClick({
        pageLink: 'search_modal',
        amplitude: true,
        event_name: SEARCH_FIELD_CLICK
      }),
    []
  );

  const handleClickTool = ({ fptiLink, prod, categoryKey }) => {
    return () => {
      const categoryFPTI = categories[categoryKey]?.categoryFPTI || categoryKey;
      //Don't clear the search if the user is just favoriting the card
      if (!fptiLink.includes('favorite')) {
        dispatch(clearSearch());
      }
      return fptiClick({
        fptiLink,
        prod,
        pageLink: `${categoryFPTI}:${
          shouldShowModal ? 'search_modal' : 'search'
        }`,
        srch: query
      });
    };
  };

  //const modalResult = results.length >= 12 ? results.splice(0, 12) : results;
  //suppress the impression event from firing when the card renders from search results
  const noop = () => {};

  const getSearchResults = useMemo(() => {
    return results.map((toolName, i) => {
      const categoryKey = tools[toolName]?.categoryKey;
      return (
        <CategoryToolTile
          key={`category-row-tool-${i}`}
          handleClickTool={handleClickTool}
          {...props}
          fptiImpression={noop}
          tool={tools[toolName]}
          path={`/businesstools/${categories[categoryKey]?.location}`}
          isRecommendCategory={false}
          lazyLoadImage={false}
        />
      );
    });
  }, [results, toolServFavorites]);
  return (
    <div id="search-row">
      <div className={isNewLayoutEligible ? 'category-grid' : 'category-row'}>
        {getSearchResults}
      </div>
    </div>
  );
};

SearchRow.propTypes = {
  categories: PropTypes.array,
  shouldShowModal: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  clearSearch: PropTypes.func.isRequired,
  fptiClick: PropTypes.func.isRequired,
  toolTileProps: PropTypes.shape({
    flatPSData: PropTypes.shape({
      tools: PropTypes.object.isRequired,
      categories: PropTypes.object.isRequired,
      isNewLayoutEligible: PropTypes.bool
    }),
    toolServFavorites: PropTypes.object
  }),
  appSearch: PropTypes.shape({
    query: PropTypes.string,
    results: PropTypes.arrayOf(PropTypes.string)
  })
};

export default SearchRow;
